module.exports = __webpack_public_path__ + "0c3b6b20d23ff50b2702bff5a1a374d6.png";